import React from 'react';
import { SUBCLASSES_BY_CLASS } from '../data/constants';
import './Subclass.css';

const Subclass = ({ character, updateCharacter }) => {
  const { class: className, level, subclass } = character;

  // In DnD 5e 2024, all classes gain their subclass at level 3
  const showSubclassChoice = level >= 3 && SUBCLASSES_BY_CLASS[className];

  if (!showSubclassChoice) {
    return null;
  }

  return (
    <div className="subclass" data-class={className}>
      <h3>Subclass</h3>
      <div className="subclass-value">
        {subclass || <span className="placeholder">Select in Traits Tab...</span>}
      </div>
    </div>
  );
};

export default Subclass;
